module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/blank-f8f34e8a582e7b3b073f04f1220db88e.png";